<div class="clock_properties">
  <small class="debug">{{me}}</small>
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
      <pre style="text-align: left; white-space: pre-line; font-size: 11px; padding-left: 50px">
        Y Year YY YYYY
        M Month in year M MM MMM
        D Day in month D DD
        E Days in week E EE EEE EEEE
        A AM/PM
        J Hour in Day 0-23
        H Hour in Dat 1-24
        K Hour in am/pm 0-11
        L Hour in dat 1-12
        N Minutes in hour N NN
        S Second in minutes SS
      </pre>
      <hr/>
      <app-font-selector (onChange)="onFontChanged($event, '', 'Clock')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
      <hr/>
      <br/>
    </div>
  }
</div>
